import { gql } from "graphql-tag";

export const LOAD_DATA = gql`
  query getInvestorDataByPage($page: Int!) {
    getInvestorDataByPage(page:$page){
        ID
        Email
        Firm_or_People
        From_Dataset
        HeadQuarters
        LinkedIn
        Location
        Name
        Phone
        Photo
        Preferred_Sector
        Stage
        Type
        Website
    }
  }
`;
export const GET_INVESTOR_DATA_BY_IDS = gql`
  query getInvestorDataByIds($idList: [String]!, $page: Int!) {
    getInvestorDataByIds(idList: $idList, page: $page) {
        ID
        Email
        Firm_or_People
        From_Dataset
        HeadQuarters
        LinkedIn
        Location
        Name
        Phone
        Photo
        Preferred_Sector
        Stage
        Type
        Website
    }
  }
`;

export const SEARCH_KEYWORD = gql`
  query SearchByKeyword($keyword: String!, $page: Int!) {
    searchByKeyword(keyword: $keyword, page: $page) {
        Email
        Firm_or_People
        From_Dataset
        HeadQuarters
        LinkedIn
        Location
        Name
        Phone
        Photo
        Preferred_Sector
        Stage
        Type
        Website
    }
  }
`;

export const GET_FILTERS = () => gql`
  query {
    getStageFilters{
      id
      value
    }
    getTypeFilters{
      id
      value
    }
    getSectorFilters{
      id
      value
    }
    getLocation{
      id
      value
    }
  }
`;

export const APPLY_FILTERS = gql`
  query FilterData($filtersType: [String], $filtersSector: [String], $filtersStage: [String], $filtersLocation: [String], $page: Int){
    filterData(filtersType: $filtersType, filtersSector: $filtersSector, 
      filtersStage: $filtersStage, filtersLocation: $filtersLocation, page: $page){
        Email
        Firm_or_People
        From_Dataset
        HeadQuarters
        LinkedIn
        Location
        Name
        Phone
        Photo
        Preferred_Sector
        Stage
        Type
        Website
    }
  }
`;

export const GET_STRIPE_DETAILS = (userId) => gql`
  query {
    getSubscriptionId(userId : "${userId}")
    getStripeId(userId :"${userId}")
  }
`;

export const SET_STRIPE_ID = (userId, stripeId) => gql`
  query {
    setStripeId(userId : "${userId}", stripeId: "${stripeId}")
  }
`;

export const SET_STRIPE_SUBSCRIPTION_ID = (userId, subscriptionId) => gql`
  query {
    setStripeId(userId : "${userId}", subscriptionId: "${subscriptionId}")
  }
`;
export const GET_BOOKMARKS_LIST = gql`
  query GetBookmarksList($userId : String!){
    getBookmarksList(userId : $userId)
  }
`;
export const CREATE_BOOKMARK_LIST = gql`
  query CreateNewBookmarkList($userId: String!, $newList: String!){
    createNewBookmarkList(userId : $userId, newListName: $newList)
  }
`;
export const ADD_TO_BOOKMARKS_LIST =  gql`
  query AddToBookmarkList($userId:String!, $listName:String!, $itemToAdd:String!){
    addToBookmarkList(userId : $userId, listName: $listName, itemToAdd: $itemToAdd)
  }
`;
export const REMOVE_FROM_BOOKMARKS_LIST = gql`
  query RemoveFromBookmarkList($userId:String!, $listName:String!, $itemToRemove:String!){
    removeFromBookmarkList(userId : $userId, listName: $listName, itemToRemove: $itemToRemove)
  }
`;
export const GET_BOOKMARKED_ITEMS = gql`
  query GetBookmarkedItems($userId : String!){
    getBookmarkedItems(userId : $userId){
      listName
      listItem
    }
  }
`;

export const LOAD_BOOKMARKS_DATA = gql`
  query GetInvestorsOfBookmarkList($userId : String!, $listName : String!, $page: Int!){
    getInvestorsOfBookmarkList(userId : $userId, listName : $listName, page: $page){
        ID
        Email
        Firm_or_People
        From_Dataset
        HeadQuarters
        LinkedIn
        Location
        Name
        Phone
        Photo
        Preferred_Sector
        Stage
        Type
        Website
    }
  }
`;